<template>
    <header class="my-header bcw clear" v-show="showdiv">
        <div class="left tac my-header__avatar">
            <img v-if="user && user.mediumAvatar" :src="user.mediumAvatar" alt="">
            <i v-else class="iconfont">&#xe6a7;</i>
        </div>
        <div v-if="user && user.id" class="left my-header__username">
            <h3 class="mtn">{{ user.nickname }}</h3>
            <div class="my-header__auth fs2 yellow mtn">
                <span v-if="user.vip==null" @click="goVip()">暂无会员特权</span>
                <span v-else @click="goVip()">{{user.vip.level.name}}</span>
                | 
                <span v-if="user.gradingLevel==null" @click="goLevel()">台球小白</span>
                <span v-else @click="goLevel()">{{user.gradingLevel.title}}</span>
            </div>
        </div>
        <div v-else class="left my-header__username">
            <van-button
                @click="login"
                size="small" class="mtm">登录</van-button>
        </div>
    </header>
</template>
<script>
import router from '@/router';
export default {
    name: 'MyHead',
    props: {
        user: {
            type: Object
        }
    },
    data(){
        return {
            showdiv:true
        }
    },
    beforeUpdate() {
    //   this.showdiv=true
    },
    methods:{
        login(){
          // 登陆
        //   console.log(process.env.NODE_ENV)
          if (process.env.NODE_ENV === 'development') {
              router.push({ name: 'login', query: { redirect: '/venue/my' }})
          }else{
              location.href = `${location.origin}/m/login?redirect=${encodeURIComponent(location.href)}`
          }
        },
        goVip:function(){
            location.href=`${location.origin}`+'/m/vip'   
        },
        goLevel:function(){
            location.href=`${location.origin}`+'/training/#/levelVerify'   
        }
    },
    // watch:{
    //     user: function (newV) {
    //         console.log(newV.id)
    //         if(!newV.id || newV.id==''){
    //             this.showdiv=true 
    //         }
    //     }
    // }
}
</script>
<style lang="less" scoped>
.my-header{
    padding: .3rem .15rem;
    &__avatar{
        width: .6rem; height: .6rem;
        line-height: .6rem;
        margin-right: .2rem;
        background-color: #eee;
        border-radius: 50%;
        overflow: hidden;
        &>img{
            width: 100%;
            height: 100%;
        }
        &>.iconfont{
            font-size: .3rem;
            color: #B3B5B2;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/MyHead.vue